import { Component, OnInit, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AuthService } from './auth/services/auth.service';
import { FeatureFlagService } from './feature-flag/services/feature-flag.service';
import { FeatureFlag } from './feature-flag/feature-flag.type';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent implements OnInit {
  private readonly authService = inject(AuthService);
  private readonly featureFlagService = inject(FeatureFlagService);

  readonly useNewLayout = toSignal(
    this.featureFlagService.checkFlagsOnChange([FeatureFlag.UseNewAdminLayout]),
    { initialValue: this.featureFlagService.hasFeatureFlagSet(FeatureFlag.UseNewAdminLayout) }
  );

  ngOnInit(): void {
    this.authService.init();
  }
}
